import { restClient } from './restClient'

interface issueTokenResponse {
  token: string
}

/**
 * Make a request to our /issue-token endpoint
 * to retrieve an access token for Courier.
 * This determines which Courier environment to use.
 * @returns string - Courier authentication token
 */
export async function fetchAuthToken() {
  try {
    const response = await restClient.get<issueTokenResponse>(
      '/api/devices/issue-token'
    )
    return response.data.token
  } catch (error) {
    console.error('Error fetching courier token:', error)
  }
}
